import * as React from 'react';

export const Right = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="-1 -1 20 20" {...props}>
    <polygon
      fill="currentColor"
      points="11.3004076 8.99751442 5.29 2.98710678 5.99710678 2.28 12.7146212 8.99751442 5.99710678 15.7150288 5.29 15.0079221"
    />
  </svg>
);
